import React, { Component } from 'react';
import { GoogleLogin } from 'react-google-login';
import {
    SOCIAL_TYPE_GOOGLE,
    SOCIAL_TYPE_FACEBOOK,
    ROLE_CUSTOMER
} from '../../utils/config/constants';
import { Redirect, withRouter } from 'react-router-dom';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import FacebookLogin from 'react-facebook-login';
class SocialSignin extends Component {
    state = {
        redirect: false,
        player_id: ''
    };

    componentDidMount = async () => {
        this.setState({ playerId: window.onesignalId });
    };
    onDone = (success, data) => {
        if (success) {
            // if (this.props.isLoginScreenCall) {
            //     this.props.loginDone();
            // }
            this.setState({ redirect: true });
        }
    };
    render() {
        const responseGoogle = response => {
            if (response.profileObj) {
                this.props.socialLoginAction(
                    {
                        playerId: this.state.playerId,
                        role: ROLE_CUSTOMER,
                        type_id: SOCIAL_TYPE_GOOGLE,
                        ...response.profileObj
                    },
                    this.onDone
                );
            }
        };
        const responseFacebook = response => {
            if (response.status != 'unknown' && response.status != '') {
                this.props.socialLoginAction(
                    {
                        playerId: this.state.playerId,
                        role: ROLE_CUSTOMER,
                        type_id: SOCIAL_TYPE_FACEBOOK,
                        ...response
                    },
                    this.onDone
                );
            } else {
                console.log('Social Login Error');
            }
        };

        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/user/profile`
            });
        }

        return (
            <ul>
                <li>
                    <FacebookLogin
                        appId=""
                        callback={responseFacebook}
                        fields="name,email"
                        textButton="Facebook"
                        onSuccess={responseFacebook}
                        className={'facebook-btn'}
                    />
                </li>
                <li>
                    <GoogleLogin
                        clientId=""
                        onSuccess={responseGoogle}
                        onFailure={responseGoogle}
                        buttonText="Google+"
                        className={'google-btn'}
                    />
                </li>
            </ul>
        );
    }
}

export default withRouter(
    connect(
        null,
        actions
    )(SocialSignin)
);



// WEBPACK FOOTER //
// ./src/components/Social/SocialSignin.js